export default __webpack_public_path__ + "static/media/image-study-admin-m@2x.5d0d95d5.png";